'use strict'
/**
 * @Desc: request请求
 * @Author: 左左
 * @Date: 2017-04-01
 */
import axios from 'axios'
import { API_BASE_URL } from "../config.js"
import loading from "./loading.js"
import {
	MessageBox
} from 'element-ui'
// 添加一个请求拦截器
axios.interceptors.request.use((config) => {
	loading.put()
	return config
})
// 添加一个响应拦截器
axios.interceptors.response.use((response) => {
	loading.pop()
	return response
})
const request = (method = 'GET') => (url, data = {}) => {
	return new Promise((resolve, reject) => {
		axios({
			method: method,
			baseURL: API_BASE_URL,
			url: url,
			params: method === 'GET' ? data : {},
			data: data,
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
			},
			timeout: 10000
		}).then((response) => {
			switch(response.data.code) {
				case 0:
					resolve(response.data.data);
					break
				case -200:
					window.location.replace("/login");
					break
				default:
					reject(response.data.message)
					if(response.data.message =='该商家未接入公众号') {
						MessageBox.alert('该商家未接入公众号, 现在去授权?', '提示', {
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
				          type: 'warning'
				        }).then(() => {
				          window.location.replace("/mp/wxAuth");
				        }).catch((e) => {
				        });
					}
					if(response.data.message && response.data.message.code ==61007){
						MessageBox.alert('该公众号已取消授权, 现在去重新授权?', '提示', {
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
				          type: 'warning'
				        }).then(() => {
				          window.location.replace("/mp/wxAuth");
				        }).catch((e) => {
				        });
					}
					break
			}
		}).catch((error) => {
			loading.pop()
			reject(error)
		})
	})
}

export default {
	get: request('GET'),
	post: request('POST'),
	put: request('PUT'),
	delete: request('DELETE')
}


// WEBPACK FOOTER //
// ./src/utils/http.js